export const pursuitLeaderConstants = {
  numberFormat: 'Number Format',
  current: 'Current',
  future: 'Future',
  commit: 'Commit',
  noCommit: 'No Commit',
};

import {
  MotifButton,
  MotifChip,
  MotifSelect,
  MotifOption,
  MotifLabel,
  MotifFormField,
} from '@ey-xd/motif-react';
import React from 'react';

export const button = () => <MotifButton>Submit</MotifButton>;

export const CurrentPill = () => (
  <MotifChip style={{ backgroundColor: '#ffe600', color: '#000000', border: 'none' }}>
    {pursuitLeaderConstants.current}
  </MotifChip>
);

export const FuturePillDashboard = () => (
  <MotifChip style={{ backgroundColor: '#E1E1E6', color: '#000000', border: 'none' }}>
    Future
  </MotifChip>
);

// export const PL_EMAIL = 'tim.kozack@ey.com';
// export const FORECAST_ID = 'tim.kozack@ey.com';
export const PL_START_DATE = '2023-10-01';
export const PL_END_DATE = '2024-12-31';
